import React from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import { QRCodeCanvas } from 'qrcode.react';

const QRWithLogo = ({
  value,
  size: propSize = 200,
  logoSrc,
  logoScale = 0.3,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  const size = isMobile ? propSize * 0.7 : isTablet ? propSize * 0.85 : propSize;
  const logoSize = size * logoScale;

  return (
    <Box
      position="relative"
      display="inline-block"
      sx={{
        width: size,
        height: size,
        maxWidth: '100%',
        '& canvas': {
          maxWidth: '100%',
          height: 'auto',
        },
      }}
    >
      <QRCodeCanvas
        value={value}
        size={size}
        bgColor="#ffffff"
        fgColor="#000000"
        level="H"
        imageSettings={{
          src: logoSrc,
          height: logoSize,
          width: logoSize,
          excavate: true,
        }}
      />
    </Box>
  );
};

export default QRWithLogo;